module.exports = __webpack_public_path__ + "img/sec4_01.93a3d273.png";